import useData from "../../../hooks/useData";
import {postBilling} from "../../../api/admin/billingReq";
import {useRef} from "react";
import useAuth from "../../../hooks/useAuth";
import FormButtons from "../../../components/common/FormButtons";
import {getErrorListFromValidation, removeErrorList} from "../../../helper/tools";
import DateInput from "../../../components/common/input-layout/DateInput";

export default function FormNewBilling({apiBilling, setShowNewBillings}) {

    const { auth } = useAuth();
    const token = auth.token;
    const { billingLastMonthList} = useData();
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    const monthRef = useRef();
    const dateRef = useRef();
    const salesReductRef = useRef();

    const handleRemoveModal = () => {
        setShowNewBillings(false)
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let body = {
            billMonth: monthRef?.current.value,
            billDate: dateRef?.current.value,
            billDateDay: (dateRef?.current.value).substring(8,10),
            billDateMonth: (dateRef?.current.value).substring(5,7),
            billDateYear: (dateRef?.current.value).substring(0,4),
            salesReduct: salesReductRef?.current.value,
        }
        await postBilling(token,body)
        .then((response) => {
            removeErrorList();
            if (!response?.response?.data?.error) {
                setShowNewBillings(false);
                apiBilling()
            } else {
                getErrorListFromValidation(response?.response?.data?.error)
            }
        })
    }

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <legend>Nouvelle facturation</legend>
            <div className="form-input">
                <label htmlFor="bill-month">Mois de facturation : </label>
                <select name="month" id="bill-month" ref={monthRef}>
                    {billingLastMonthList?.map((month, index) => (
                        <>
                            <option name="month" key={index}>{month?.monthList[0]}</option>
                            <option name="month" key={index}>{month?.monthList[1]}</option>
                            <option name="month" key={index}>{month?.monthList[2]}</option>
                        </>
                    ))}
                </select>
            </div>
            <div className="flex billing-date-discount-row">
                <div className="form-input">
                    <label htmlFor="bill-date">Date des factures : </label>
                    <DateInput ref={dateRef} id="bill-date" max="9999-12-31" defaultValue={formattedDate} className="bill-date-input"/>
                </div>
                <div className="form-input sales-reduct-input">
                    <label>Remise commerciale appliquée à toutes les factures : </label>
                    <input ref={salesReductRef} type="text" defaultValue="0"/>
                </div>
            </div>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    )
}